// extracted by mini-css-extract-plugin
export default {"container":"DocumentsHistoryPage_container__0XN2k"};